export default __webpack_public_path__ + "static/media/Living in the Light_ A guide to personal transformation ( PDFDrive ) (2).11246a8f.pdf";